import CryptoJS from 'crypto-js';
// security-hardening-2026: single source of truth for this key — see
// helpers/encryptionKey.js for why it is not env-configurable.
import CRYPTO_KEY from "./encryptionKey";

const textToBase64 = (value) => {
  const textString = value;
  const words = CryptoJS.enc.Utf8.parse(textString);
  const base64 = CryptoJS.enc.Base64.stringify(words);
  return base64;
};

const base64ToString = (value) => {
  const base64 = value;
  const words = CryptoJS.enc.Base64.parse(base64);
  const textString = CryptoJS.enc.Utf8.stringify(words);
  return textString;
};

export const encryptString = (value) => textToBase64(CryptoJS.AES.encrypt(value, CRYPTO_KEY));

export const decryptString = (value) => {
  if (!value || typeof value !== 'string') {
    return '';
  }
  try {
    const baseText = base64ToString(value);
    const decryptId = CryptoJS.AES.decrypt(baseText, CRYPTO_KEY).toString(CryptoJS.enc.Utf8);
    return decryptId;
  } catch (e) {
    console.error('Error decrypting string:', e);
    return '';
  }
};
